import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ORGANIZATION_TYPE } from "@constants";
import { Modal } from "../../../../../components";
import ModifyRate from "./ModifyRate";
import "./OrganizationFeesModal.scss";

const OrganizationFeesModal = props => {
	const { lang } = global;
	const {
		show,
		onHide,
		effectiveServiceFees,
		rkPayRateHistory,
		pFeeRateHistory,
		processingFees,
		details,
		type,
		onSaveProcessingFee,
		onSaveServiceFee,
	} = props;

	const [showRKRate, setShowRKRate] = useState(false);
	const [prFees, setProcessingFees] = useState([]);

	const { CLIENT, LAW_ENFORCEMENT_DEPARTMENT } = ORGANIZATION_TYPE;

	const mapFeeObject = (pFees, showFee = false) => ({
		id: pFees.Id,
		effectiveFrom: pFees.EffectiveFrom,
		modifier: pFees.Modifier,
		name: pFees.Name,
		origin: pFees.Origin,
		processingFeeId: pFees.ProcessingFeeId,
		rate: pFees.Rate,
		show: showFee,
	});

	const createProcessingFees = () => {
		if (prFees.length > 0) {
			const pfeesAux = processingFees.map(pFee => {
				const pFeeAux = prFees.find(
					pFees => pFees.processingFeeId === pFee.ProcessingFeeId,
				);
				if (pFeeAux) {
					return mapFeeObject(pFee, pFeeAux.show);
				}
				return mapFeeObject(pFee);
			});
			setProcessingFees(pfeesAux);
		} else {
			const pfeesAux = processingFees.map(pFee => mapFeeObject(pFee));
			setProcessingFees(pfeesAux);
		}
	};

	useEffect(() => {
		if (processingFees.length > 0) {
			createProcessingFees();
		}
	}, [rkPayRateHistory, pFeeRateHistory, processingFees, show]);

	const filterRateHistory = pFeeId => {
		const filtered = pFeeRateHistory.filter(rate => rate.ProcessingFeeId === pFeeId);
		return filtered;
	};

	const handleShowRKRate = () => {
		setShowRKRate(!showRKRate);
	};

	const handleShowPFee = pFeeId => {
		const pfeesAux = prFees.map(pFee => {
			if (pFee.processingFeeId === pFeeId) {
				return {
					...pFee,
					show: !pFee.show,
				};
			}
			return pFee;
		});
		setProcessingFees(pfeesAux);
	};

	return (
		<Modal
			id="oragization-fees-modal"
			show={show}
			onHide={() => onHide()}
		>
			<Modal.Header>
				<Modal.Title>{lang.t("Configure Platform Charges")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div style={{ marginLeft: "15px", marginRight: "15px" }}>
					<div className="grouped-service-fees">
						<div className="row v-align service-fee">
							<div className="col-xs-3">
								<Choose>
									<When
										condition={effectiveServiceFees && effectiveServiceFees[0]}
									>
										<strong>{lang.t("RKPay Rate")}</strong>
									</When>
									<Otherwise>
										<strong>{lang.t("RKPay rate not found")}</strong>
									</Otherwise>
								</Choose>
							</div>
							<div className="col-xs-7 text-right">
								<If condition={effectiveServiceFees && effectiveServiceFees[0]}>
									<strong>{effectiveServiceFees[0].PercentageFee}%</strong>
								</If>
							</div>
							<div className="col-xs-1">
								<button
									style={{ paddingLeft: 10 }}
									type="button"
									className="btn btn-link"
									onClick={handleShowRKRate}
								>
									<i
										style={{ cursor: "pointer" }}
										className={`h4 rkf ${showRKRate ? "rkf-chevron-up" : "rkf-chevron-down"}`}
									/>
								</button>
							</div>
						</div>

						{showRKRate && (
							<ModifyRate
								rateHistory={rkPayRateHistory}
								feeTypeId={3}
								onSaveFee={onSaveProcessingFee}
							/>
						)}
					</div>
					<For
						each="pFee"
						of={prFees}
					>
						<If
							condition={
								(type === LAW_ENFORCEMENT_DEPARTMENT &&
									(details.NonRKPayPaymentsEnabled ||
										pFee.processingFeeId === 5)) ||
								type === CLIENT
							}
						>
							<div className="grouped-service-fees">
								<div
									className="row v-align service-fee"
									key={`pFee-${pFee.id}`}
								>
									<div className="col-xs-3">
										<strong>{pFee.name}</strong>
									</div>
									<div className="col-xs-7 text-right">
										<strong>{pFee.rate}%</strong>
									</div>
									<div className="col-xs-1">
										<button
											style={{ paddingLeft: 10 }}
											type="button"
											className="btn btn-link"
											onClick={() => {
												handleShowPFee(pFee.processingFeeId);
											}}
										>
											<i
												style={{ cursor: "pointer" }}
												className={`h4 rkf ${pFee.show ? "rkf-chevron-up" : "rkf-chevron-down"}`}
											/>
										</button>
									</div>
								</div>
								{pFee.show && (
									<ModifyRate
										rateHistory={filterRateHistory(pFee.processingFeeId)}
										feeTypeId={pFee.processingFeeId}
										onSaveFee={onSaveServiceFee}
									/>
								)}
							</div>
						</If>
					</For>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-primary"
					onClick={() => onHide()}
				>
					{lang.t("Close")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

OrganizationFeesModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	effectiveServiceFees: PropTypes.array,
	processingFees: PropTypes.array,
	rkPayRateHistory: PropTypes.array,
	pFeeRateHistory: PropTypes.array,
	details: PropTypes.object,
	type: PropTypes.number,
	onSaveProcessingFee: PropTypes.func,
	onSaveServiceFee: PropTypes.func,
};

OrganizationFeesModal.defaultProps = {
	show: false,
	onHide: () => {},
	effectiveServiceFees: [],
	processingFees: [],
	rkPayRateHistory: [],
	pFeeRateHistory: [],
	details: {},
	type: 0,
	onSaveProcessingFee: () => {},
	onSaveServiceFee: () => {},
};

export default OrganizationFeesModal;
